const toggleSearchBar=(state=false,action)=>{
    switch (action.type){
        case "TOGGLESEARCHBAR":
            return !state
        default:
            return state
    }
};
export default toggleSearchBar;